import React from "react";
import "./NovaLanding.css";
import { SUPPORT_CONTACT_ITEMS } from "@shared/errors/supportContacts";

const CONTACT_ITEMS = SUPPORT_CONTACT_ITEMS;
const slugifyLabel = (label) =>
  label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export default function ContactModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="modal-overlay contact-overlay" onClick={onClose}>
      <div
        className="modal-content contact-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="contact-modal-title"
        data-testid="contact-modal"
      >
        <button
          className="modal-close contact-modal-close"
          onClick={onClose}
          type="button"
          data-testid="contact-modal-close-button"
        >
          ×
        </button>
        <div className="contact-modal-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
          </svg>
        </div>
        <h2 className="modal-title" id="contact-modal-title">
          Contact Information
        </h2>
        <ul className="contact-modal-list">
          {CONTACT_ITEMS.map((item) => (
            <li key={item.label}>
              <span className="contact-modal-label">{item.label}</span>
              <a
                href={item.href}
                className="contact-modal-value"
                data-testid={`contact-modal-${slugifyLabel(item.label)}-link`}
              >
                {item.value}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
